/**
 * Product Card Mobile Slider - AB Test Version with Swiper
 * Initializes Swiper sliders for product cards on mobile
 */

let observerStarted = false;

const startObserver = () => {
  if (observerStarted || !document.body) {
    return;
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        initProductCardSwipers();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  observerStarted = true;
};

export function initProductCardSwipers() {
  const SwiperClass = window.Swiper;
  if (!SwiperClass) {
    return;
  }

  const swipers = document.querySelectorAll(".product-card-swiper");

  swipers.forEach((swiperEl) => {
    // Check if already initialized
    if (swiperEl.swiper) {
      return;
    }

    // Get the parent product card to find controls
    const productCard = swiperEl.closest(".product-card--slider-test");

    if (!productCard) {
      return;
    }

    // Find controls in the product card (they're in the content area now)
    const nextButton = productCard.querySelector(
      ".product-card-swiper-button-next"
    );
    const prevButton = productCard.querySelector(
      ".product-card-swiper-button-prev"
    );
    const pagination = productCard.querySelector(
      ".product-card-swiper-pagination"
    );

    // Initialize Swiper
    new SwiperClass(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,

      // Navigation arrows
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },

      // Pagination dots
      pagination: {
        el: pagination,
        clickable: true,
        dynamicBullets: false,
      },

      // Touch settings
      touchRatio: 1,
      touchAngle: 45,
      grabCursor: true,

      // Prevent clicks when swiping
      preventClicks: true,
      preventClicksPropagation: true,

      // Speed
      speed: 300,

      // Accessibility
      a11y: {
        enabled: true,
        prevSlideMessage: "Previous image",
        nextSlideMessage: "Next image",
      },
    });
  });

  // Re-initialize if products are loaded dynamically (e.g., via AJAX)
  window.initProductCardSwipers = initProductCardSwipers;
  startObserver();
}
